import { createFileRoute, redirect } from '@tanstack/react-router';

/** The old address of the people list; it is the People topic under Company now. */
export const Route = createFileRoute('/t/$tenant/settings/people')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/t/$tenant/settings/company/people',
      params: { tenant: params.tenant },
      replace: true,
    });
  },
});
